import paths, { rootPaths } from './paths';

export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'menu.dashboard',
      icon: 'th',
      to: rootPaths.dashboardRoot,
      active: true,
      claimLabel: 'adminDashboard',
      tourId: 'tour-dashboard',
    }
  ]
};
export const employeeRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'menu.employeeDashboard',
      icon: 'th',
      to: paths.employeeDashboard,
      active: true,
      claimLabel: 'employeeDashboard',
      tourId: 'tour-dashboard',
    }
  ]
};
export const clientRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'menu.clientDashboard',
      icon: 'th',
      to: paths.clientDashboard,
      active: true,
      claimLabel: 'clientDashboard',
      tourId: 'tour-dashboard',
    }
  ]
};
export const relationsRoutes = {
  label: 'relaties',
  labelDisable: true,
  children: [
    {
      name: 'menu.relations',
      icon: 'users',
      //to: rootPaths.root,
      to: rootPaths.relationsRoot,
      active: true,
      claimLabel: 'relations',
      tourId: 'tour-relations',
    },
  ]
};
export const proposalsRoutes = {
  label: 'offertes',
  labelDisable: true,
  children: [
    {
      name: 'menu.proposals',
      icon: 'file',
      to: rootPaths.proposalsRoot,
      active: true,
      claimLabel: 'proposal',
      tourId: 'tour-proposals',
    }
  ]
};
export const planningRoutes = {
  label: 'menu.planningParent',
  children: [
    {
      name: 'menu.orders',
      icon: 'tasks',
      to: rootPaths.orderRoot,
      active: true,
      claimLabel: 'orders',
      tourId: 'tour-orders'
    },
    {
      name: 'menu.planning',
      icon: 'calendar-alt',
      to: rootPaths.planningRoot,
      active: true,
      claimLabel: 'planning',
      tourId: 'tour-planning',
    },
    {
      name: 'menu.jobs',
      icon: 'tasks',
      to: rootPaths.jobsRoot,
      active: true,
      claimLabel: 'jobs'
    },
    {
      name: 'menu.myTimesheet',
      icon: 'clock',
      to: rootPaths.myTimesheetRoot,
      active: true,
      claimLabel: 'timesheet'
    }
  ]
};
export const administationRoutes = {
  label: 'menu.administration',
  children: [
    {
      name: 'menu.settings',
      icon: 'cog',
      to: rootPaths.settingsRoot,
      active: true,
      claimLabel: 'settings',
    },
    {
      name: 'menu.users',
      icon: 'user',
      to: rootPaths.usersRoot,
      active: true,
      claimLabel: 'users',
      tourId: 'tour-users',
    },
    {
      name: 'menu.templates',
      icon: 'layer-group',
      to: rootPaths.templatesRoot,
      active: true,
      claimLabel: 'proposalTemplates',
    },
    {
      name: 'menu.task',
      icon: 'check-square',
      to: rootPaths.workTasksRoot,
      active: true,
      claimLabel: 'workTasks'
    }
  ]
};

export const billingRoutes = {
  label: 'menu.billing',
  children: [
    {
      name: 'menu.invoices',
      icon: 'file-invoice',
      to: rootPaths.invoiceRoutes,
      active: true,
      claimLabel: 'invoices',
      tourId: 'tour-invoices',
    }
  ]
};

export const reportsRoutes = {
  // label: 'Rapporten',
  label: 'menu.reports',
  children: [
    {
      name: 'menu.hoursRegistration',
      icon: 'file-alt',
      to: rootPaths.hoursRegistration,
      active: true,
      claimLabel: 'reports',
      tourId: 'tour-hoursRegistration',
    },
    {
      name: 'menu.leaveManagement',
      icon: 'calendar-check',
      to: rootPaths.leaveManagementRoot,
      active: true,
      claimLabel: 'leaveManagement',
    },
    {
      name: 'menu.myLeaves',
      icon: 'calendar-check',
      to: rootPaths.myLeavesRoot,
      active: true,
      claimLabel: 'myLeaves',
      tourId: 'tour-myLeaves',
    },
    {
      name: 'menu.attendance',
      icon: 'clock',
      to: rootPaths.attendanceRoot,
      active: true,
      claimLabel: 'attendance',
    },
  ]
};
export const Profile = {
  label: 'Account',
  children: [
    {
      name: 'menu.profile',
      icon: 'user-circle',
      to: rootPaths.profileRoot,
      active: true,
      claimLabel: 'profile',
      tourId: 'tour-profile',
    },
    {
      name: 'menu.mySubscription',
      icon: 'sync-alt',
      to: rootPaths.mySubscriptionRoot,
      active: true,
      claimLabel: 'mySubscription'
    },
    {
      name: 'menu.notifications',
      icon: 'bell',
      to: rootPaths.notificationsRoot,
      active: true,
      claimLabel: 'notifications',
      tourId: 'tour-notifications',
    },
  ]
};
export const supportRoutes = {
  label: 'Helpdesk',
  children: [
    {
      name: 'menu.support',
      icon: 'headphones',
      to: rootPaths.supportRoot,
      active: true,
      claimLabel: 'support',
      tourId: 'tour-support',
    },
    {
      name: 'menu.releases',
      icon: 'file',
      to: rootPaths.releaseNotesRoot,
      active: true,
      claimLabel: 'release-notes'
    }
  ]
};

export default [dashboardRoutes, employeeRoutes, clientRoutes, relationsRoutes, proposalsRoutes, planningRoutes, administationRoutes,billingRoutes, reportsRoutes, Profile, supportRoutes,];